<div class="fwc-container sae-branding">
  @if (true) {
    <div class="fwc-row">
      @if (header) {
        <div class="fwc-flex sae-logos">
          @if (header.brandLogo && header.brandLogo !== '') {
            <img src="{{header.brandLogo}}" [alt]="'Anthem'" />
          }
          @if (header.universityLogo && header.universityLogo !== '') {
            <div class="logo-divider"></div>
          }
          @if (header.universityLogo && header.universityLogo !== '') {
            <img [src]="header.universityLogo"
              [alt]="header.universityLabel" />
          }
        </div>
      }
      @if (!token || token === '') {
        <div class="logout-btn">
          <button class="fwc-btn fwc-btn-primary" (click)="navigateTo('/login')">Login</button>
        </div>
      } @else {
        <div class="nav-links">
          <div class="horiz-nav-container fwc-table">
            <div class="horz-nav-header">
              <div id="dashboard_menu_pointer" (click)="tabClick('secure/dashboard','dashboard_menu');toggleHeader('dashboard_menu')" (keydown)="handleKeyPress($event, 'secure/dashboard','dashboard_menu')" class="nav-link horiz-nav-label" tabindex="0" role="button" aria-label="Dashboard">Dashboard</div>
            </div>
            <div class="horz-nav-header">
              <div id="students_menu_pointer" (click)="tabClick('secure/students','students_menu');toggleHeader('students_menu')" (keydown)="handleKeyPress($event, 'secure/students','students_menu')" class="nav-link horiz-nav-label" tabindex="0" role="button" aria-label="Students">Students</div>
            </div>
            <div class="horz-nav-header">
              <div (click)="toggleHeader('reporting_menu')" (keydown)="handleToggleKeyPress($event, 'reporting_menu')" id="reporting_menu_pointer" class="nav-link horiz-nav-label" tabindex="0" role="button" aria-label="Reporting menu" aria-haspopup="true" aria-expanded="false">Reporting
                <span id="reporting_menu_caret" class="fwc-icon fwc-icon-caret-filled nav-icon-caret" aria-hidden="true"></span>
              </div>
              <div class="dropdown-menu" id="reporting_menu" #reportingMenu>
                <div class="fwc-row j-center menu-container">
                  <div class="fwc-flex-colum nav-col">
                    <h4 (click)="tabClick('/secure/reports','reporting_menu')" (keydown)="handleKeyPress($event, '/secure/reports','reporting_menu')" tabindex="0" role="button" aria-label="Reports">Reports</h4>
                    <div class="sub-link" (click)="tabClick('/secure/reports','reporting_menu', 'dependent')" (keydown)="handleKeyPress($event, '/secure/reports','reporting_menu', 'dependent')" tabindex="0" role="button" aria-label="Dependent reports"><a>Dependent</a></div>
                    <div class="sub-link" (click)="tabClick('/secure/reports','reporting_menu', 'waiver')" (keydown)="handleKeyPress($event, '/secure/reports','reporting_menu', 'waiver')" tabindex="0" role="button" aria-label="Waiver reports"><a>Waiver</a></div>
                    <div class="sub-link" (click)="tabClick('/secure/reports','reporting_menu', 'student-listing')" (keydown)="handleKeyPress($event, '/secure/reports','reporting_menu', 'student-listing')" tabindex="0" role="button" aria-label="Student and Dependent Listing reports"><a>Student & Dependent Listing</a></div>
                    <div class="sub-link" (click)="tabClick('/secure/reports','reporting_menu', 'denied-waiver')" (keydown)="handleKeyPress($event, '/secure/reports','reporting_menu', 'denied-waiver')" tabindex="0" role="button" aria-label="Denied Waiver reports"><a>Denied Waiver</a></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="horz-nav-header">
              <div id="account_menu_pointer" (click)="tabClick('secure/account','account_menu');toggleHeader('account_menu')" (keydown)="handleKeyPress($event, 'secure/account','account_menu')" class="nav-link horiz-nav-label" tabindex="0" role="button" aria-label="Account Settings">Account Settings</div>
            </div>
          </div>
          <button class="fwc-btn fwc-btn-secondary left-xs" (click)="logout()">Log Out</button>
        </div>
      }
      <div class="nav-links-mobile">
        <img (click)="openModalSlider()" (keydown)="handleKeyPress($event, '', '')" class="hamburger-menu" src="assets/images/iconography-system-menu-hamburger.png" tabindex="0" role="button" alt="Open menu">
      </div>
    </div>
  }
  @if (stories) {
    <sae-account-toggle-header [stories]="stories"></sae-account-toggle-header>
  }
</div>
@if (showNavBackground) {
  <div class="ant-header-click-out" id="clickOut"></div>
}

<fwc-modal-slide #fwcSlideParent [id]="'fwcMobileHeadSlider'" direction="right" lock-scroll="true" caller-id="openSlideModal"
label-aria-modal-header="Slide In Modal Header" (fwc-modal-close)="closeModalSlider()"></fwc-modal-slide>

<template id="modalSlideContent1">
  <div #fwcSlideChild id="template-holder-mobileHead">
    <div #fwcSlideContent class="slide-modal-content" id="mobile-header-slider">
      <div class="mobile-nav-links">
        @if (!token || token === '') {
          <a class="nav-link" (click)="navigateTo('/login')">Login</a>
        } @else {
          <a class="nav-link" (click)="navigateTo('/secure/dashboard');closeModalSlider()">Dashboard</a>
          <a class="nav-link" (click)="navigateTo('/secure/students');closeModalSlider()">Students</a>
          <a class="nav-link" (click)="tabClick('/secure/reports','', 'dependent');closeModalSlider()">Reports</a>
          <a class="nav-link left-xs" (click)="tabClick('/secure/reports','', 'dependent');closeModalSlider()">Dependent</a>
          <a class="nav-link left-xs"  (click)="tabClick('/secure/reports','', 'waiver');closeModalSlider()">Waiver</a>
          <!--  <a class="nav-link" (click)="navigateTo('/account');closeModalSlider()">Account Settings</a>-->
          <a class="nav-link" (click)="logout()">Log Out</a>
        }
      </div>
    </div>
  </div>
</template>
@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}
